// Today's date (YYYY-MM-DD) in India time, regardless of device timezone.
export const istToday = () =>
  new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Kolkata", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());

// Any Date (or ISO string) → YYYY-MM-DD in India time.
export const istDate = (d) =>
  new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Kolkata", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(d));
